import { Point } from "PosterEditor/model/poster-types";
import { last } from "lodash"; // Function to draw a line with calculated offset points for flanking curves
import { getOffsetPoint } from "PosterEditor/utils/point-utils";

export const drawLine = (
  ctx: CanvasRenderingContext2D,
  points: Point[],
  offset: number = 0,
  color: string,
  width: number,
  dot?: number | undefined,
  dash?: number | undefined,
  alpha: number = 1,
  smooth: boolean = true
) => {
  ctx.beginPath();
  ctx.lineWidth = width;
  ctx.strokeStyle = color;
  if (dot && dash) {
    ctx.setLineDash([dot, dash]);
  } else {
    ctx.setLineDash([]);
  }
  for (let i = 0; i < points.length - 1; i++) {
    const previousPoint = points[i - 1];
    const thisPoint = points[i];
    const nextPoint = points[i + 1];
    if (
      previousPoint === undefined ||
      thisPoint === undefined ||
      nextPoint === undefined ||
      previousPoint.x === undefined ||
      previousPoint.y === undefined ||
      thisPoint.x === undefined ||
      thisPoint.y === undefined ||
      nextPoint.x === undefined ||
      nextPoint.y === undefined
    ) {
      //console.error("Point is missing x or y");
      continue;
    }

    // if (i === 0) {
    //   const offsetPoint = getOffsetPoint(point1, point2, offset);
    //   ctx.moveTo(point1.x + offsetPoint.x, point2.y + offsetPoint.y); // Start with offset
    // }
    const cpX = (thisPoint.x + nextPoint.x) / 2;
    const cpY = (thisPoint.y + nextPoint.y) / 2;
    const offsetPoint = getOffsetPoint(
      previousPoint,
      thisPoint,
      nextPoint,
      offset
    );

    ctx.quadraticCurveTo(
      thisPoint.x + offsetPoint.x,
      thisPoint.y + offsetPoint.y,
      cpX + offsetPoint.x,
      cpY + offsetPoint.y
    ); // Draw the quadratic curve with offset
  }
  const penultimatePoint = points[points.length - 1];
  const thisPoint = last(points);
  const lastPoint = points[points.length - 2];

  if (
    thisPoint !== undefined &&
    lastPoint !== undefined &&
    penultimatePoint !== undefined &&
    lastPoint.x !== undefined &&
    lastPoint.y !== undefined &&
    penultimatePoint.x !== undefined &&
    penultimatePoint.y !== undefined
  ) {
    // Draw the final segment to the last point

    const lastOffset = getOffsetPoint(
      lastPoint,
      penultimatePoint,
      thisPoint,
      offset
    );
    ctx.lineTo(
      penultimatePoint.x + lastOffset.x,
      penultimatePoint.y + lastOffset.y
    );
  }
  ctx.globalAlpha = alpha;
  ctx.stroke(); // Draw the stroke
  ctx.closePath();
  ctx.globalAlpha = 1;
};
